export default __webpack_public_path__ + "static/slide_4-9d5b66d6f8f3954cda38c1139eced186.png";